import React, {useEffect, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";

type ImageModalProps = {
  onClose: () => void;
  onSuccess: (data: { source: string; caption?: string }) => void;
  uploadImageApi: (file: File) => Promise<{ src: string; type: string; }[]>;
  isOpen: boolean
};

export const ImageModal = ({onClose, onSuccess, uploadImageApi, isOpen}: ImageModalProps) => {
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [caption, setCaption] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) setFile(e.target.files[0]);
  };

  const onSubmit = async () => {
    if (!file) {
      alert('Выберите картинку');
      return;
    }
    try {
      setIsLoading(true)
      const uploadedUrl = await uploadImageApi(file);
      onSuccess({source: uploadedUrl[0]?.src, caption: caption.trim() || undefined});
      onClose();
      setCaption('')
      setPreview(null)
      setFile(null)
    } catch {
      alert('Ошибка загрузки изображения');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Добавить картинку</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" width="100%" gap={2}>
          <input type="file" accept="image/*" onChange={onFileChange}/>

          {preview && (
            <div style={{marginTop: 10, textAlign: 'center'}}>
              <img
                src={preview}
                alt="Preview"
                style={{maxWidth: '100%', maxHeight: 200, objectFit: 'contain'}}
              />
            </div>
          )}

          <TextField fullWidth placeholder="Описание" label="Описание" value={caption}
                     onChange={(e) => setCaption(e.target.value)}/>
        </Box>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button onClick={onSubmit} disabled={!file || isLoading} variant="contained" color="primary">
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  )
};
